<template>
    <div>
        <card-header title="Course Outline" icon="fa-list-alt"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Sections" icon="fa-list-alt" />

                <draggable v-model="course.course_outline" handle=".drag-handle" @end="completeDrag" draggable=".t-card-list-item">
                    <transition-group>

                        <card-list-item
                            class="t-card-list-item"
                            v-for="o in course.course_outline"
                            :key="o.id"
                            @click="$openCard('edit-section', {courseId: course.id, outlineId: o.id, sectionId: o.section_id}, card)"
                            :class="{'active': (child && child.definition.component === 'edit-section' && o.section_id === parseInt(child.props.sectionId))}"
                        >
                            <template #icon><i class="fa-fw fas fa-list"></i></template>
                            <template #content>
                                <div class="columns">
                                    <div class="column is-10">
                                        <div class="tile-title">{{ o.title }}</div>
                                        <div class="meta">{{o.sections.title}}</div>
                                    </div>
                                    <div class="column has-text-right">
                                        <p class="control">
                                            <i class="fas fa-sort drag-handle"></i>
                                        </p>
                                    </div>
                                </div>
                            </template>
                            <template #details>
                                <div class="mt-2">
                                    <toolbar class="toolbar">
                                        <b-tooltip label="Edit Details"><button class="icon-only" @click.stop="$openCard('edit-outline-item', {courseId: course.id, outlineId: o.id}, card)"><i class="far fa-pencil"></i></button></b-tooltip>
                                        <b-tooltip label="Remove Section"><button class="icon-only" @click.stop="deleteOutline(o)"><i class="far fa-remove"></i></button></b-tooltip>
                                    </toolbar>
                                </div>
                            </template>
                        </card-list-item>
                    </transition-group>
                </draggable>

                <card-list-item class="pb-5" no-hover>
                    <template #icon><i class="fa-fw fas fa-plus"></i></template>
                    <template #content>
                        <div class="columns">
                            <div class="column is-10">
                                <div class="mb-2">
                                    <b-select expanded placeholder="Add to outline..." v-model="type">
                                        <option value="">Please Select</option>
                                        <option value="new">New Section</option>
                                        <option value="shared">Shared Section</option>
                                    </b-select>
                                </div>

                                <div class="mb-2" v-if="type === 'shared'">
                                    <b-select expanded placeholder="Shared Section" v-model="sectionSelect" @input="title = sectionSelect.title">
                                        <option :value="s" v-for="s in sections">{{ s.title }}</option>
                                    </b-select>
                                </div>

                                <div>
                                    <b-field label="Title" label-position="inside">
                                        <b-input v-model="title"></b-input>
                                    </b-field>
                                </div>

                            </div>
                            <div class="column has-text-right">
                                <p class="control">
                                    <button class="button is-primary" :disabled="!type || !title || (type === 'shared' && !sectionSelect)" @click="addOutline"><i class="far fa-fw fa-plus"></i></button>
                                </p>
                            </div>
                        </div>
                    </template>
                </card-list-item>
            </card-list>

        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';

    import draggable from "vuedraggable";
    import Toolbar from "../../TIER/components/Toolbar.vue";

    export default {
        components: {Toolbar, draggable, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                course: {outline: []},
                confirmDelete: false,
                dirty: null,
                type: null,
                title: null,
                sections: [],
                sectionSelect: null,
            };
        },
        methods: {
            loadCourse: function(force) {
                this.$emit('loading', true);
                http.get('courses/new/' + this.props.courseId, {force}).then(response => { // TODO: temporary endpoint
                    if (!response.data.outline) response.data.outline = []; //TODO temp
                    this.course = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            loadSections(force) {
                this.$emit('loading', true);

                http.get('sections/', {force}).then(response => {
                    this.sections = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            addOutline() {
                http.post('courses/outline/', {
                    type: 'SECTION',
                    course_id: this.course.id,
                    type_id: (this.sectionSelect) ? this.sectionSelect.id : null,
                    section_id: (this.sectionSelect) ? this.sectionSelect.id : null,
                    sort: this.course.course_outline.length + 1,
                    title: this.title
                }, {force: true}).then(response => {
                    console.log(response.data);
                    this.course.course_outline.push(response.data);
                    this.type = null;
                    this.title = '';
                    this.sectionSelect = null;
                }, err => {
                    console.log(err);
                });
            },
            deleteOutline(section) {
                if (window.confirm('Are you sure you want to delete this section from this course? The section will still remain and can be re-added as a shared section')) {
                    http.delete('courses/outline/' + section.id, {force: true}).then(response => {
                        this.course.course_outline = this.course.course_outline.filter(o => o.id !== section.id);
                    }, err => {
                        console.log(err);
                    });
                }

            },
            completeDrag: function () {
                http.post('courses/outline/order', this.course.course_outline.map(i => i.id)).then(response => {

                });
            },
            reload() {
                this.loadCourse(true);
            }
        },
        watch: {
            'props.courseId': function() {
                this.dirty = null;
                this.loadCourse();
            },
            // 'course': {
            //     deep: true,
            //     handler: function() {
            //         this.dirty = (this.dirty !== null);
            //         if (!this.$TIER.saveAlert.active && this.dirty)
            //             this.$saveAlert(true, 'Are you done editing this course? Unsaved changes will be lost.');
            //     }
            // }
        },
        mounted() {
            this.loadCourse();
            this.loadSections();
        }
    };
</script>

<style lang="scss" scoped>
    .drag-handle {
        cursor: ns-resize;
    }

    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .tile-details {
        margin-top: 0.5rem;
    }
</style>
